import React, { useState } from 'react';
import {useHistory} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActions } from '@/stores/action/widget.action';

import request from '@/services/request.service';
import StorageService from '@/services/storage.service';
import { toFormData } from '@/utils/convert.util';
import { getLocaleWordContent } from '@/utils/language.util';


function Email({ModalActions}) {

    const history = useHistory();
    const [pin, setPin] = useState('');
    const userid = new StorageService().user_id.get();

    const handleClose = (e) => {
      ModalActions.showModal({show:false});
    }

    const handleChange = (e) => {
        if(e) e.preventDefault();
        setPin(e.target.value);
    }

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        _submit_pin(pin);
    }

    const _submit_pin = async () => {
        const params = {user_id : userid, pin : pin};
        const rsp = await request.post('/member/pin_api', toFormData(params)).then(response => response.data)
        if (Number(rsp) > 1 ) {
            alert("Pin error");
            setPin('');
            return rsp
        } else {
            alert("success !");
            ModalActions.showModal({show:false});
            history.push('/home')
            return rsp;
        }
    }

    return (
    <div className="popup_01 popup_pin">
        <div className="popup_inner01">
          <div className="popup_header">
            <h3>SMS {getLocaleWordContent('인증')} </h3>
            <img src={require('@/resources/assets/images/close.png')} className="popup_close" alt="close" onClick={handleClose}/>
          </div>
          <div className="popup_body inputbox">
            <p className='text-center'>{getLocaleWordContent('보내기 전에 승인코드를 입력하십시오')}</p>
            {/* <div className="sub_btn_box">
              <p>User ID</p>
              <input type="button" defaultValue={userid} className="btn01" name="id"/>
            </div> */}
            <div className="sp20"></div>
            <div className="input_form">
              <input type="text" className="input01" placeholder={getLocaleWordContent('인증코드')} name="pin" onChange={handleChange}/>
            </div>
            <div className="sub_btn_box">
              <input type="button" defaultValue="제출" className="btn01" onClick={handleSubmit}/>
            </div>
          </div>
        </div>
      </div>
    )
}
export default connect(
  null,
  dispatch => ({
    ModalActions: bindActionCreators(modalActions, dispatch)
  })
)(Email);
